import LineSuitcaseIcon from 'LuxKit/Icons/line/LineSuitcaseIcon'
import { useOrdersByDepartureStatus } from 'hooks/useOrdersByDepartureStatus'
import type { ComponentProps } from 'react'
import { useMemo } from 'react'
import { useIntl } from 'react-intl'
import NavBarListItem from 'components/NavKit/NavBarListItem'
import { sum } from 'lib/array/arrayUtils'
import NavBarListItemIcon from '../NavBarListItemIcon'
import usePurchaseSynonymLabels from 'hooks/usePurchaseSynonymLabels'

type InheritedListItemProps = Pick<ComponentProps<typeof NavBarListItem>, 'onClick'>

function AccountMenuMyEscapesListItem(props: InheritedListItemProps) {
  const intl = useIntl()
  const { upcoming } = useOrdersByDepartureStatus()

  const upcomingCopy = useMemo<string | undefined>(() => {
    const numberOfUpcoming = sum([upcoming.length])
    if (numberOfUpcoming === 0) {
      return undefined
    }
    return intl.formatMessage(
      {
        id: 'LhUJ5csC5hnMOdoNj6x0',
        defaultMessage: '{count, plural, one {# upcoming} other {# upcoming}}',
      },
      { count: numberOfUpcoming },
    )
  }, [intl, upcoming.length])

  const { myPurchases: title } = usePurchaseSynonymLabels()

  return <NavBarListItem
    {...props}
    startIcon={<NavBarListItemIcon Icon={LineSuitcaseIcon} />}
    title={title}
    titleFormat="titlecase"
    endTitle={upcomingCopy}
    to="/account/my-escapes"
  />
}

export default AccountMenuMyEscapesListItem
